export default {
    // --------Title--------
    rolesAssignation: '身份分配',
    addingRoleTitleWithDetails: '身份分配详细信息',
    permissions: '权限',
    selectWhichActionsThePeopleWithThisRoleCanPerform: '选择该身份的人可以执行指定的操作',

    // --------Permission-------
    branchUsers: '分行用户',
    
    // --------MUI--------
    userRouteType: '用户路由类型',
    roleTitle: '身份标题',
    mainUsers: '主要用户',

};